export default {
  paginate(state, payload) {
    state.pagination = payload;
  },
};



// WEBPACK FOOTER //
// ./src/store/notifications/mutations.js